import { useCallback, useMemo } from 'react'

import { useUpdateChatMessageMutation } from '@crew/apis/chat/chatApis'
import { useChatMessage } from '@crew/states'

import { useAppDispatch, useAppSelector } from 'states/hooks'
import { RelatedEntity } from '@crew/models/common'

export const useFeedMessageListItem = (chatMessageId: string) => {
  const dispatch = useAppDispatch()
  const { message, isError } = useChatMessage(
    chatMessageId,
    dispatch,
    useAppSelector
  )

  const loggedInUser = useAppSelector((state) => state.app.loggedInUser)

  const [updateChatMessageMutation] = useUpdateChatMessageMutation()

  // 自分が投稿したメッセージ判定（自分のメッセージのみ、権限があれば添付ファイル削除が可能とする）
  const isMyMessage = useMemo(
    () => message?.createdById === loggedInUser?.id,
    [loggedInUser?.id, message?.createdById]
  )

  // 添付ファイル削除後にメッセージ更新APIを実行してwebsocketによる表示の更新を行う
  const updateChatMessage = useCallback(async () => {
    if (!message) {
      return
    }

    // メンション
    const mentionUserIds: string[] = message.mentions
      ? Object.values(message.mentions).map((item) => {
          return item.userId
        })
      : []

    // 関連エンティティ
    const relatedEntities: RelatedEntity[] = message.entityReferences
      ? Object.values(message.entityReferences).map((item) => {
          return {
            entityType: item.sourceEntityType,
            entityRecordId: item.sourceEntityRecordId,
          }
        })
      : []

    try {
      await updateChatMessageMutation({
        chatMessage: {
          chatMessageId: message?.id,
          text: message?.text,
          version: message?.version,
        },
        mentionUserIds:
          mentionUserIds.length === 0 ? undefined : mentionUserIds,
        relatedTargets:
          relatedEntities.length === 0 ? undefined : relatedEntities,
      })
    } catch (err) {
      // 成功可否によるトースト表示などはないのでエラー時はエラーログを出力
      console.error(err)
    }
  }, [message, updateChatMessageMutation])

  return {
    message,
    isError,
    isMyMessage,
    updateChatMessage,
  }
}
